// extracted by mini-css-extract-plugin
export default {"reassignButton":"ReassignLoanApplication_reassignButton__606oh"};